import { BasePage } from '@/components/ui/base-page'

export function MercantiPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add MercantiPage specific content here */}
    </BasePage>
  )
}